import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import {
  getIdContest,
  editContest,
  deleteContest
} from 'api/concourse';
//components
import Title from 'components/backoffice/texts/title';
import ContestForm from 'components/backoffice/forms/contestForm';

const EditContest = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [contest, setContest] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const { setTitle } = useOutletContext()

  const detailContest = async () => {
    try {
      const { data, status } = await getIdContest(id);
      if ([200, 201].includes(status)) {
        data?.user_library?.forEach((user) => {
          user.label = user?.email || user?.username;
          user.value = parseInt(user?.id, 10);
        });
        if (data?.client) {
          data.client.value = parseInt(data.client.id, 10);
          data.client.label = data.client.name;
        }
        if (data?.user_special) {
          data.user_special.value = parseInt(data.user_special?.id, 10);
          data.user_special.label = data.user_special?.email || data.user_special.username;
        }

        const { name, client, user_special, discount, user_library } = data;
        setContest({
          name: name,
          client: client,
          user_special: user_special,
          discount: discount,
          user_library: user_library,
        });
      } else {
        console.error(`Error on getIdContest: ${status} - ${data}`);
      }
    } catch (error) {
      console.error('Error getting Contest Details - (getIdContest)--->', error);
    }
  };

  useEffect(() => {
    detailContest();
  }, []);

  useEffect(() => {
    if (contest) {
      setTitle(t('edit', { title: contest?.name }))
    }
  }, [contest, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const libraryUsersIdsArray = values.user_library.map((user) => user?.customId);
    const { name, client, user_special, discount } = values;
    let data = {
      name: name,
      client: client?.value,
      user_special: user_special?.value,
      discount: parseInt(discount),
      user_library: libraryUsersIdsArray,
    };
    try {
      const response = await editContest(id, data);
      const { status, data: responseData } = response;
      if (responseData?.name?.[0] === "There is already a concourse with that name") {
        toast.error(t('nameContestAlreadyExists'), { theme: 'colored' });
        setLoading(false);
        return;
      }
      if ([200, 201].includes(status)) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/contests', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log('error editContest', error);
    }
    setLoading(false)
  }, []);

  const handleDelete = useCallback(
    async () => {
      try {
        const { status } = await deleteContest(id);
        if (status === 204) {
          toast.success(t('eliminadocorrectamente'));
          navigate('/intranet/contests', { replace: true });
        } else {
          toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
        }
      } catch (error) {
        console.log(error);
      }
    },
    [openModalDelete],
  );

  return (
    <div>
      <Title text={t('editContest')} />
      <ContestForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={contest}
        onDelete={handleDelete}
        getDetailContest={detailContest}
        idContest={id}
      />
    </div>
  );
};

export default EditContest;